import { render } from "./WorkshopsComponent.vue?vue&type=template&id=a6f728ba&scoped=true"
import script from "./WorkshopsComponent.vue?vue&type=script&lang=js"
export * from "./WorkshopsComponent.vue?vue&type=script&lang=js"

import "./WorkshopsComponent.vue?vue&type=style&index=0&id=a6f728ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f728ba"]])

export default __exports__